var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('service-ticket-details-dialog',{attrs:{"ticketId":_vm.ticketToEdit,"visible":_vm.dialogVisible},on:{"dialogClosed":_vm.editFinished}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99e13234","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/app/servicetickets/components/ServiceTicketListFromEmail.vue
// module id = oFnY
// module chunks = 1